import { ROLES } from '@/constants/roles';
import formatRoutes from '@/helpers/user-redesign/formatRoutes';

const routes = [
  {
    path: '/redesign/my-polls',
    name: 'my-polls',
    component: () => import('@/modules/UserPolls/views/my-polls.vue'),
    meta: {
      title: 'Задания',
      accessList: [ROLES.certificate, ROLES.member],
    },
  },
  {
    path: '/redesign/polls/event/:eventId/stage/:stageId/poll/:id',
    name: 'my-event-poll',
    component: () => import('@/modules/Poll/views/poll.vue'),
    meta: {
      title: 'Задания',
      accessList: [ROLES.certificate, ROLES.member],
      backRoute: false,
    },
  },
  {
    path: '/redesign/polls/event/:eventId/stage/:stageId/poll/:pollId/passing/:id',
    name: 'my-poll-passing',
    component: () => import('@/modules/Poll/views/poll-passing.vue'),
    meta: {
      title: 'Задания',
      accessList: [ROLES.certificate, ROLES.member],
      subdrawer: true,
    },
  },
];

export default formatRoutes(routes, true, false);
